<div class="h-full w-full relative">
  <div class="flex items-center absolute top-2 right-2 sm:top-5 sm:right-5 z-10">
    <lib-dropdown-select
      placeholder="Idioma"
      i18n-placeholder
      [options]="languageOptions"
      [selectedValue]="selectedLanguage()"
      [type]="'small'"
      [showClear]="false"
      (selectionChange)="onLanguageChange($event)"
    />
  </div>
  <p-toast />
  <router-outlet />
</div>
